import { ReactSVG } from 'react-svg';
import cslx from 'clsx';
import { Button } from '@web/utils';
import plusIcon from '../../assets/icons/functions/plus-icon.svg';

type ModalWrapperPs = {
  setIsOpen: (val: boolean) => void;
  submitHandler: () => void;
  okOnly?: boolean;
  submitText?: string;
  cancelText?: string;
  cancelHandler?: () => void;
  children: React.ReactNode;
  t: any;
  controls?: boolean;
  header?: boolean;
};

const ModalWrapper: React.FC<ModalWrapperPs> = (props) => {
  const {
    submitHandler,
    children,
    submitText,
    cancelText,
    okOnly,
    setIsOpen,
    cancelHandler,
    t,
    controls = true,
    header = true,
  } = props;

  return (
    <div className="bg-primary-white rounded-14-0 shadow text-body1 text-primary-black md:w-1/2 max-w-80-percent max-h-[90%] text-center overflow-hidden">
      {header && (
        <div className="modal-head bg-grey-100 h-3-0 relative">
          <div className="rotate-45 absolute top-0-7 right-1-0 cursor-pointer opacity-50">
            <ReactSVG
              data-testid="close"
              src={plusIcon}
              onClick={() => setIsOpen(false)}
            />
          </div>
        </div>
      )}
      <div className=" p-2-0 ">
        {/* model content */}
        <div
          className={cslx(controls && 'mb-2-0 md:mb-3-2')}
          role="modal-content"
        >
          {children}
        </div>
        {/* modal buttons */}
        {controls && (
          <div className="flex justify-between mx-auto">
            {!okOnly && (
              <Button
                variant="secondary"
                onClick={() => cancelHandler?.() || setIsOpen(false)}
              >
                {cancelText || t('global.cancel')}
              </Button>
            )}
            <Button
              onClick={() => submitHandler()}
              className={okOnly ? 'mx-auto' : ''}
            >
              {submitText || t('global.submit')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalWrapper;
